import { render, staticRenderFns } from "./schedule-data-table-activity.component.vue?vue&type=template&id=7972c2ed&scoped=true&"
import script from "./schedule-data-table-activity.component.vue?vue&type=script&lang=ts&"
export * from "./schedule-data-table-activity.component.vue?vue&type=script&lang=ts&"
import style0 from "./schedule-data-table-activity.component.vue?vue&type=style&index=0&id=7972c2ed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972c2ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
